// extracted by css-extract-rspack-plugin
export default {"strip":"EnvironmentStrip-module__strip__bkyrg","stripButton":"EnvironmentStrip-module__stripButton__f8G9V"};